import { createAction } from "redux-actions";

import {
  GET_LOGS,
  GET_LOGS_COUNT,
  SET_LOG_SEARCH_FILTERS,
  SET_LOGS_CURRENT_PAGE,
  SET_LOGS_ITEMS_PER_PAGE,
  SET_LOGS_NO_ENTRIES_MESSAGE,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const { getLogs, getLogsPending, getLogsFulfilled, getLogsRejected } =
  createAsyncActions(GET_LOGS, "getLogs");

export const {
  getLogsCount,
  getLogsCountPending,
  getLogsCountFulfilled,
  getLogsCountRejected,
} = createAsyncActions(GET_LOGS_COUNT, "getLogsCount");

export const setLogSearchFilters = createAction(SET_LOG_SEARCH_FILTERS);
export const setCurrentPage = createAction(SET_LOGS_CURRENT_PAGE);
export const setLogsItemsPerPage = createAction(SET_LOGS_ITEMS_PER_PAGE);
export const setNoEntriesMessageLogs = createAction(
  SET_LOGS_NO_ENTRIES_MESSAGE
);



// WEBPACK FOOTER //
// ./src/features/log/actions/getLogsActions.js